export default __webpack_public_path__ + "static/media/anass-bouchfar.045fd683.pdf";